/* eslint-disable */
import * as Types from '../schema/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const FrequencySaleNotificationsDocument = gql`
    query FrequencySaleNotifications {
  frequencySaleNotifications {
    id
    name
  }
}
    `;

/**
 * __useFrequencySaleNotificationsQuery__
 *
 * To run a query within a React component, call `useFrequencySaleNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFrequencySaleNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFrequencySaleNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFrequencySaleNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<FrequencySaleNotificationsQuery, FrequencySaleNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FrequencySaleNotificationsQuery, FrequencySaleNotificationsQueryVariables>(FrequencySaleNotificationsDocument, options);
      }
export function useFrequencySaleNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FrequencySaleNotificationsQuery, FrequencySaleNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FrequencySaleNotificationsQuery, FrequencySaleNotificationsQueryVariables>(FrequencySaleNotificationsDocument, options);
        }
export function useFrequencySaleNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FrequencySaleNotificationsQuery, FrequencySaleNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FrequencySaleNotificationsQuery, FrequencySaleNotificationsQueryVariables>(FrequencySaleNotificationsDocument, options);
        }
export type FrequencySaleNotificationsQueryHookResult = ReturnType<typeof useFrequencySaleNotificationsQuery>;
export type FrequencySaleNotificationsLazyQueryHookResult = ReturnType<typeof useFrequencySaleNotificationsLazyQuery>;
export type FrequencySaleNotificationsSuspenseQueryHookResult = ReturnType<typeof useFrequencySaleNotificationsSuspenseQuery>;
export type FrequencySaleNotificationsQueryResult = Apollo.QueryResult<FrequencySaleNotificationsQuery, FrequencySaleNotificationsQueryVariables>;
export const MessengersDocument = gql`
    query Messengers {
  messengers {
    id
    name
  }
}
    `;

/**
 * __useMessengersQuery__
 *
 * To run a query within a React component, call `useMessengersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessengersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessengersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMessengersQuery(baseOptions?: Apollo.QueryHookOptions<MessengersQuery, MessengersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessengersQuery, MessengersQueryVariables>(MessengersDocument, options);
      }
export function useMessengersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessengersQuery, MessengersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessengersQuery, MessengersQueryVariables>(MessengersDocument, options);
        }
export function useMessengersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MessengersQuery, MessengersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MessengersQuery, MessengersQueryVariables>(MessengersDocument, options);
        }
export type MessengersQueryHookResult = ReturnType<typeof useMessengersQuery>;
export type MessengersLazyQueryHookResult = ReturnType<typeof useMessengersLazyQuery>;
export type MessengersSuspenseQueryHookResult = ReturnType<typeof useMessengersSuspenseQuery>;
export type MessengersQueryResult = Apollo.QueryResult<MessengersQuery, MessengersQueryVariables>;
export const CountriesDocument = gql`
    query Countries {
  countries {
    id
    country
    phoneCode
    code
  }
}
    `;

/**
 * __useCountriesQuery__
 *
 * To run a query within a React component, call `useCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
      }
export function useCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export function useCountriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CountriesQuery, CountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CountriesQuery, CountriesQueryVariables>(CountriesDocument, options);
        }
export type CountriesQueryHookResult = ReturnType<typeof useCountriesQuery>;
export type CountriesLazyQueryHookResult = ReturnType<typeof useCountriesLazyQuery>;
export type CountriesSuspenseQueryHookResult = ReturnType<typeof useCountriesSuspenseQuery>;
export type CountriesQueryResult = Apollo.QueryResult<CountriesQuery, CountriesQueryVariables>;
export const UpdateOrganizerProfileDocument = gql`
    mutation UpdateOrganizerProfile($input: UpdateOrganizerProfileTypeInput!) {
  updateOrganizerProfile(input: $input) {
    email
    firstName
    lastName
    phone
    companyName
    companyWebsite
    emailVerified
    messengerUserName
    country {
      id
    }
    messenger {
      id
      name
    }
    frequencySaleNotification {
      id
      name
    }
  }
}
    `;
export type UpdateOrganizerProfileMutationFn = Apollo.MutationFunction<UpdateOrganizerProfileMutation, UpdateOrganizerProfileMutationVariables>;

/**
 * __useUpdateOrganizerProfileMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizerProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizerProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizerProfileMutation, { data, loading, error }] = useUpdateOrganizerProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizerProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizerProfileMutation, UpdateOrganizerProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizerProfileMutation, UpdateOrganizerProfileMutationVariables>(UpdateOrganizerProfileDocument, options);
      }
export type UpdateOrganizerProfileMutationHookResult = ReturnType<typeof useUpdateOrganizerProfileMutation>;
export type UpdateOrganizerProfileMutationResult = Apollo.MutationResult<UpdateOrganizerProfileMutation>;
export type UpdateOrganizerProfileMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizerProfileMutation, UpdateOrganizerProfileMutationVariables>;
export const GetOrganizerInfoDocument = gql`
    query GetOrganizerInfo {
  organizer {
    id
    email
    firstName
    lastName
    phone
    avatar
    companyName
    companyWebsite
    messengerUserName
    emailVerified
    banActive
    country {
      id
      country
      slug
      phoneCode
    }
    messenger {
      id
      name
    }
    frequencySaleNotification {
      id
      name
    }
    stripeStatus {
      stripeStatus
      verifyAccountUrl
      eventId
    }
    subscription {
      plan
      dateOfStart
      dateOfEnd
      canceled
    }
  }
}
    `;

/**
 * __useGetOrganizerInfoQuery__
 *
 * To run a query within a React component, call `useGetOrganizerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizerInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizerInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizerInfoQuery, GetOrganizerInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizerInfoQuery, GetOrganizerInfoQueryVariables>(GetOrganizerInfoDocument, options);
      }
export function useGetOrganizerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizerInfoQuery, GetOrganizerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizerInfoQuery, GetOrganizerInfoQueryVariables>(GetOrganizerInfoDocument, options);
        }
export function useGetOrganizerInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizerInfoQuery, GetOrganizerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizerInfoQuery, GetOrganizerInfoQueryVariables>(GetOrganizerInfoDocument, options);
        }
export type GetOrganizerInfoQueryHookResult = ReturnType<typeof useGetOrganizerInfoQuery>;
export type GetOrganizerInfoLazyQueryHookResult = ReturnType<typeof useGetOrganizerInfoLazyQuery>;
export type GetOrganizerInfoSuspenseQueryHookResult = ReturnType<typeof useGetOrganizerInfoSuspenseQuery>;
export type GetOrganizerInfoQueryResult = Apollo.QueryResult<GetOrganizerInfoQuery, GetOrganizerInfoQueryVariables>;
export const SendOrganizerVerifyEmailDocument = gql`
    mutation SendOrganizerVerifyEmail {
  sendOrganizerVerifyEmail
}
    `;
export type SendOrganizerVerifyEmailMutationFn = Apollo.MutationFunction<SendOrganizerVerifyEmailMutation, SendOrganizerVerifyEmailMutationVariables>;

/**
 * __useSendOrganizerVerifyEmailMutation__
 *
 * To run a mutation, you first call `useSendOrganizerVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOrganizerVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOrganizerVerifyEmailMutation, { data, loading, error }] = useSendOrganizerVerifyEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendOrganizerVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendOrganizerVerifyEmailMutation, SendOrganizerVerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOrganizerVerifyEmailMutation, SendOrganizerVerifyEmailMutationVariables>(SendOrganizerVerifyEmailDocument, options);
      }
export type SendOrganizerVerifyEmailMutationHookResult = ReturnType<typeof useSendOrganizerVerifyEmailMutation>;
export type SendOrganizerVerifyEmailMutationResult = Apollo.MutationResult<SendOrganizerVerifyEmailMutation>;
export type SendOrganizerVerifyEmailMutationOptions = Apollo.BaseMutationOptions<SendOrganizerVerifyEmailMutation, SendOrganizerVerifyEmailMutationVariables>;
export const DeleteOrganizerDocument = gql`
    mutation DeleteOrganizer {
  deleteOrganizer
}
    `;
export type DeleteOrganizerMutationFn = Apollo.MutationFunction<DeleteOrganizerMutation, DeleteOrganizerMutationVariables>;

/**
 * __useDeleteOrganizerMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizerMutation, { data, loading, error }] = useDeleteOrganizerMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteOrganizerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizerMutation, DeleteOrganizerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizerMutation, DeleteOrganizerMutationVariables>(DeleteOrganizerDocument, options);
      }
export type DeleteOrganizerMutationHookResult = ReturnType<typeof useDeleteOrganizerMutation>;
export type DeleteOrganizerMutationResult = Apollo.MutationResult<DeleteOrganizerMutation>;
export type DeleteOrganizerMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizerMutation, DeleteOrganizerMutationVariables>;
export type FrequencySaleNotificationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type FrequencySaleNotificationsQuery = { __typename?: 'Query', frequencySaleNotifications: Array<{ __typename?: 'FrequencySaleNotificationType', id: number, name: string }> };

export type MessengersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MessengersQuery = { __typename?: 'Query', messengers: Array<{ __typename?: 'MessengerProxyType', id?: number | null, name?: string | null }> };

export type CountriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'CountryProxyType', id: number, country?: string | null, phoneCode?: string | null, code?: string | null }> };

export type UpdateOrganizerProfileMutationVariables = Types.Exact<{
  input: Types.UpdateOrganizerProfileTypeInput;
}>;


export type UpdateOrganizerProfileMutation = { __typename?: 'Mutation', updateOrganizerProfile: { __typename?: 'OrganizerType', email: string, firstName?: string | null, lastName?: string | null, phone?: string | null, companyName?: string | null, companyWebsite?: string | null, emailVerified: boolean, messengerUserName?: string | null, country?: { __typename?: 'CountryType', id?: number | null } | null, messenger?: { __typename?: 'Messenger', id?: number | null, name?: string | null } | null, frequencySaleNotification?: { __typename?: 'FrequencySaleNotificationType', id: number, name: string } | null } };

export type GetOrganizerInfoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOrganizerInfoQuery = { __typename?: 'Query', organizer: { __typename?: 'OrganizerProxyType', id: number, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, avatar?: string | null, companyName?: string | null, companyWebsite?: string | null, messengerUserName?: string | null, emailVerified: boolean, banActive: boolean, country?: { __typename?: 'CountryProxyType', id: number, country?: string | null, slug?: string | null, phoneCode?: string | null } | null, messenger?: { __typename?: 'MessengerProxyType', id?: number | null, name?: string | null } | null, frequencySaleNotification?: { __typename?: 'FrequencySaleNotificationType', id: number, name: string } | null, stripeStatus?: { __typename?: 'OrganizerStripeStatusType', stripeStatus?: Types.PaymentsStripeStatusEnum | null, verifyAccountUrl?: string | null, eventId?: number | null } | null, subscription?: { __typename?: 'SubscriptionProxyType', plan?: string | null, dateOfStart: any, dateOfEnd: any, canceled: boolean } | null } };

export type SendOrganizerVerifyEmailMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SendOrganizerVerifyEmailMutation = { __typename?: 'Mutation', sendOrganizerVerifyEmail: boolean };

export type DeleteOrganizerMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DeleteOrganizerMutation = { __typename?: 'Mutation', deleteOrganizer: boolean };
